import type { ProductionBatch, ProductionSummary } from '../Services/HCP/flows/production-batch.interface'

export function productionBatchLabel(batch: ProductionBatch): string {
  if (batch.type === 'DIVISION') return batch.divisionNumber != null ? `DV${String(batch.divisionNumber).padStart(2, '0')}` : 'Divisão'
  if (batch.type === 'REWORK') return batch.reworkNumber != null ? `RT${String(batch.reworkNumber).padStart(2, '0')}` : 'Retrabalho'
  return 'Original'
}

export function orderProductionOverview(batches: readonly ProductionBatch[], summary?: ProductionSummary | null, commercialQuantity?: number | null): ProductionSummary {
  if (summary) return summary
  const commercial = batches.filter((batch) => batch.type !== 'REWORK')
  const reworks = batches.filter((batch) => batch.type === 'REWORK')
  const positions: ProductionSummary['positions'] = []
  commercial.forEach((batch) => {
    const position = positions.find((item) => item.flow === batch.hcpCurrentFlow
      && item.displayCode === batch.hcpCurrentFlowDisplayCode && item.finished === batch.hcpFinished)
    if (position) position.quantity += batch.quantity
    else positions.push({ flow: batch.hcpCurrentFlow, displayCode: batch.hcpCurrentFlowDisplayCode, finished: batch.hcpFinished, quantity: batch.quantity })
  })
  return {
    commercialQuantity: commercialQuantity ?? commercial.reduce((total, batch) => total + batch.quantity, 0),
    reworkQuantity: reworks.reduce((total, batch) => total + batch.quantity, 0),
    commercialBatchesCount: commercial.length,
    reworkBatchesCount: reworks.length,
    hasMultiplePositions: positions.length > 1,
    positions,
  }
}
